import MultipleSelectDropdown from '../components/MultipleSelectDropdown';

export default MultipleSelectDropdown;